import React from 'react';
import mixpanel from 'mixpanel-browser';
import {
  PhoneInTalk as PhoneInTalkIcon,
  Email as EmailIcon,
  LocationOn as LocationOnIcon,
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  X as XIcon,
} from '@mui/icons-material';

import { Box, Stack, Typography } from '@mui/material';
import { messages } from '../../../constants/Forms/contact.js';

import './Contact.css';

export const BusinessContact = () => {
  const trackSocialMediaLinks = (e) => {
    const link = e.target.closest('a');
    const linkUrl = link.href;
    const linkText = link.name;

    mixpanel.track('Contact Us Form ', {
      action: `${linkText} Clicked`,
      link_url: linkUrl,
      path: '/contact',
    });
  };
  return (
    <>
      <div className="businessContact">
        <div className="businessHeader">
          <h5 className="business_header_h5"> {messages.businessContactInfo}</h5>
          <p className="business_header_p"> {messages.readyToHelp} </p>
        </div>
        <div className="contactList">
          <a
            href={`tel:${messages.businessPhoneNumber}`}
            className="aContactList"
            name="Phone Link"
            onClick={trackSocialMediaLinks}
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <PhoneInTalkIcon />
              <Typography className="h5ContactList"> {messages.businessPhoneNumber}</Typography>
            </Stack>
          </a>

          <a
            href={`mailto:${messages.businessEmail}`}
            className="aContactList"
            name="Email Link"
            onClick={trackSocialMediaLinks}
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <EmailIcon />
              <Typography className="h5ContactList"> {messages.businessEmail}</Typography>
            </Stack>
          </a>

          <a
            href={messages.mapsUrl}
            className="aContactList"
            onClick={trackSocialMediaLinks}
            name="MapURL Link"
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <LocationOnIcon />
              <Typography className="h5ContactList"> {messages.businessAddress} </Typography>
            </Stack>
          </a>
        </div>

        <Box className="embeddedMap">
          <iframe
            src={`https://www.google.com/maps?q=${encodeURIComponent(messages.businessAddress)}&output=embed`}
            title="Google Map"
            width="100%"
            height="100%"
            className="iframe"
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          />
        </Box>
        <div className="socialIcons">
          <a
            href="https://www.facebook.com/people/CashClever/61574125204930/"
            id="facebookLink"
            className="socialIconsTag"
            name="Facebook Link"
            onClick={trackSocialMediaLinks}
          >
            <FacebookIcon sx={{ fill: 'white' }} />
          </a>
          <a
            href="https://www.linkedin.com/company/cashclever-corp/"
            id="linkedInLink"
            onClick={trackSocialMediaLinks}
            name="LinkedIn Link"
          >
            <LinkedInIcon sx={{ fill: 'white' }} />
          </a>
          <a
            href="https://x.com/CC_CoFounders/"
            id="twitterLink"
            onClick={trackSocialMediaLinks}
            name="Twitter Link"
          >
            <XIcon sx={{ fill: 'white' }} />
          </a>
        </div>
      </div>
    </>
  );
};
